import { isOCSCreative, RedirectPartialConfig } from 'common/js/format-helper';
import { FormatStateStore } from 'common/stores/FormatStateStore';
import { DisplayConfigType } from '../config';

import { MRAIDFormatStateStore } from './format-state-stores/mraid-format-state-store';
import { OcsMRAIDFormatStateStore } from './format-state-stores/ocs-mraid-format-state-store';

export function getFormatStateStore(
  adContext: AdContext,
  formatConfig: DisplayConfigType
): FormatStateStore {
  if (adContext.creativeSource === 'redirect') {
    if (isOCSCreative(formatConfig as RedirectPartialConfig)) {
      return new OcsMRAIDFormatStateStore(formatConfig);
    }

    return new MRAIDFormatStateStore(formatConfig);
  }

  return new FormatStateStore();
}
